"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockStakingAccrualERC20Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockStakingAccrualERC20Factory = /** @class */ (function (_super) {
    __extends(MockStakingAccrualERC20Factory, _super);
    function MockStakingAccrualERC20Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockStakingAccrualERC20Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockStakingAccrualERC20Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockStakingAccrualERC20Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockStakingAccrualERC20Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockStakingAccrualERC20Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockStakingAccrualERC20Factory;
}(contracts_1.ContractFactory));
exports.MockStakingAccrualERC20Factory = MockStakingAccrualERC20Factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
        ],
        name: "CreditScoreContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "ExitCooldownDurationSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_cooldownEndTimestamp",
                type: "uint256",
            },
        ],
        name: "ExitCooldownStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Exited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_streamId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "FundsWithdrawnFromSablier",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "SablierContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_newStreamId",
                type: "uint256",
            },
        ],
        name: "SablierStreamIdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "TokensRecovered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "claimStreamFunds",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "cooldowns",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "exit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "exitCooldownDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getExchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "string",
                name: "__name",
                type: "string",
            },
            {
                internalType: "string",
                name: "__symbol",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "__decimals",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_exitCooldownDuration",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
            {
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "init",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "recoverTokens",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "sablierContract",
        outputs: [
            {
                internalType: "contract ISablier",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "sablierStreamId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_creditScoreAddress",
                type: "address",
            },
        ],
        name: "setCreditScoreContract",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "setExitCooldownDuration",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "setSablierContract",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_sablierStreamId",
                type: "uint256",
            },
        ],
        name: "setSablierStreamId",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "stake",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "stakeWithPermit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IPermittableERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "startExitCooldown",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "token",
                type: "uint256",
            },
        ],
        name: "toStakedToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "stTokenAmount",
                type: "uint256",
            },
        ],
        name: "toStakingToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
